import {Styles} from "../Styles/Styles";
import styled from "styled-components";
import useGlobalSettings from "../Provider/useGlobalSettings";
import {useEffect, useState} from "react";
import {API} from "../API/api";
import {useParams} from "react-router-dom";


interface iEMail {
    header: {
        id: string,
        from: string,
        to: string,
        timestamp?: Date,
    }
    subject: string,
    body: string,
    missions: {text: string, id: string}[]
}

const MyStyles = {
    Mission: styled.div``,
    Missions: styled.div`
        display: grid;
        grid-template-columns: 60px 1fr;
        padding-left: 30px;
        padding-bottom: 30px;
        div {
            text-align: left;
            min-height: 30px;
            display: flex;
            align-items: center;
        }
        input {
            width: 20px;
            height: 20px;
        }
    `,
    eMail: {
        Header: {
            TimeStamp: styled.div`
                width: 100%;
                text-align: right;
                font-size: small;
                color: white;
            `,
            MetaSourceFrame: styled.div`
                color: white;
                display: grid;
                grid-template-columns: 50px calc(100% - 60px);
            `,
            From: styled.div``,
            To: styled.div``,
            Subject: styled.div`
                font-size: larger;
                padding-top: 15px;
                display: grid;
                grid-template-columns: 110px calc(100% - 120px);`,
        }
    }
}

const prepairBody = (body: string) => {
    return body
}

export const _EMail = ({ data } :
   {data: {
       id: string,
       from: string,
       to: string,
       subject: string,
       timestamp?: Date,
       body: string,
       missions: {text: string, id: string}[]}}) => {

    const { Actions, activeMission } = useGlobalSettings();

    useEffect(() => {
        Actions.readEMail( data.id )
    }, [data.id]);

    return <Styles.eMail.Frame>
        <Styles.eMail.Header>
            <MyStyles.eMail.Header.TimeStamp>{data.timestamp?.toLocaleString("de-DE", {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            })}</MyStyles.eMail.Header.TimeStamp>
            <MyStyles.eMail.Header.MetaSourceFrame>
                <MyStyles.eMail.Header.From>Von:</MyStyles.eMail.Header.From>
                <MyStyles.eMail.Header.From>{data.from}</MyStyles.eMail.Header.From>
                <MyStyles.eMail.Header.To>An:</MyStyles.eMail.Header.To>
                <MyStyles.eMail.Header.To>{data.to}</MyStyles.eMail.Header.To>
            </MyStyles.eMail.Header.MetaSourceFrame>

            <MyStyles.eMail.Header.Subject>
                <div>Betreff:</div>
                <div>{data.subject}</div>
            </MyStyles.eMail.Header.Subject>
        </Styles.eMail.Header>
        <Styles.eMail.Content>{prepairBody(data.body)}</Styles.eMail.Content>
        <MyStyles.Missions>
            { data.missions?.map( mission =>
                <div key={mission.id}>
                    <input type="checkbox" id={mission.id}
                           checked={activeMission === mission.id}
                           onChange={() => Actions.ActiveMission.set(mission.id)}
                    />
                    <MyStyles.Mission>{mission.text}</MyStyles.Mission>
                </div>
            )}
        </MyStyles.Missions>
    </Styles.eMail.Frame>
}


export const EMail = () => {

    const { emailID } = useParams();
    const { Actions } = useGlobalSettings();
    const [email, setEMail] = useState<iEMail|undefined>(undefined);

    useEffect( () => {
        Actions.Fetching.start( 'specificMail' );
        const timer = setTimeout( () =>
            API.getEMail(emailID ?? "")
                .then( res => setEMail( res.data ) )
                .catch( err => console.error(err) )
                .finally( () => Actions.Fetching.stop( 'specificMail' ) ), 2000 );

        return () => clearTimeout( timer );
    },[emailID])

    if( ! email )
        return null

    return <_EMail data={{
        id: email.header.id,
        timestamp: email.header?.timestamp ? new Date( email.header.timestamp ) : undefined,
        from: email.header.from,
        to: email.header.to,
        subject: email.subject,
        body: email.body,
        missions: email.missions
    }} />
}